export const DEPOSIT_TYPE = {
    AGENCY: 0,
    AGENT: 1,
    DEALER: 2,
    USER: 3
}